import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { from, Observable, of } from 'rxjs';
import { get } from 'aws-amplify/api';
import {
  PiData,
  PiPoint,
  PiPointDictionary,
  PiPoints,
} from '../models/pi-data.model';
import { RuleToPi } from '../models/rule.model';
import { PiPointUtilityService } from './pi-point-utility.service';

@Injectable({
  providedIn: 'root',
})
export class PiDataService {
  constructor(
    private apiService: ApiService,
    private piPointUtilityService: PiPointUtilityService,
  ) {}

  public GetLatestPiDatasEquipement(equipementId: string): Observable<any[]> {
    const options = {
      queryParams: {
        equipementId: equipementId.toString(),
      },
    };
    return this.apiService.get(
      `/PiData/GetLatestPiDatasbyRuleUniqueId/`,
      options,
    );
  }

  public GetPiDatasEquipementByDate(
    equipementId: string,
    thresholdDate: Date,
  ): Observable<any[]> {
    const options = {
      queryParams: {
        equipementId: equipementId.toString(),
        thresholdDate: thresholdDate.toISOString(),
      },
    };
    return this.apiService.get(
      `/PiData/GetPiDatasbyRuleUniqueIdAndDate`,
      options,
    );
  }

  public GetPiDatasByRule(RuleId: string): Observable<any[]> {
    return this.apiService.get(
      `/PiStats/GetLatestPiDatasbyRuleUniqueId/${RuleId}`,
    );
  }

  public GetPisValues(
    input: RuleToPi[] | undefined,
    fromDate: any,
    toDate?: any,
    interpolationResolutionInMinutes?: any,
  ): Observable<PiPoints> {
    return this.piPointUtilityService.GetPisValuesChunked(
      input,
      fromDate,
      toDate,
      interpolationResolutionInMinutes,
    );
  }

  public GetPiPointsDetails(
    input: RuleToPi[] | undefined,
  ): Observable<PiPointDictionary> {
    if (!input || input.length === 0) {
      return of({});
    }
    const options = input.map((item) => item.piPointFK);
    return this.apiService.post(`/PiData/GetPiPointDetailsByWebId`, options);
  }

  public GetPiPointForTag(tag: string): Observable<PiPoint> {
    return this.apiService.get(`/PiData/GetPiPointForTag?tag=${tag}`);
  }

  public GetPiPointsTagsByRuleId(ruleUid: string): Observable<PiPoint[]> {
    return this.apiService.get(
      `/PiData/GetPiPointsTagsByRuleId?ruleUid=${ruleUid}`,
    );
  }
}
